import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { post } from 'aws-amplify/api';
import ImagesStats from '../../../components/ImagesStats/ImagesStats';
import './UserSubscriptions.scss';

function UserSubscriptions () {
	const { username, email } = useSelector(state => state.userData || {});
	const { subscribed, stripe_subscription_id } = useSelector(state => state.eventsData?.imagesStats || {});
	const [subscriptionData, setSubscriptionData] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchSubscriptionData();
	}, [username]);

	const fetchSubscriptionData = async () => {
		if (!username) {
			setLoading(false);
			return;
		}

		try {
			const response = await post({
				apiName: 'eventsapi',
				path: '/get-stripe-subscription',
				options: {
					body: { username }
				}
			}).response;

			const data = await response.body.json();
			setSubscriptionData(data);
		} catch (err) {
			console.error("Error fetching subscription data:", err);
		} finally {
			setLoading(false);
		}
	};

	const handleSubscribe = async () => {
		try {
			if (!username || !email) {
				console.error('User data not available');
				return;
			}
			console.log(['username and email', username, email]);
			const response = await post({
				apiName: 'eventsapi',
				path: '/create-subscription',
				options: {
					body: { userId: username, email }
				}
			}).response;

			const data = await response.body.json();
			if (data.url) {
				window.location.href = data.url; // redirect to Stripe Checkout
			}
		} catch (err) {
			console.error("Error starting subscription:", err);
		}
	};

	const handleCancel = async () => {
		try {
			const response = await post({
				apiName: 'eventsapi',
				path: '/cancel-subscription',
				options: {
					body: { subscriptionId : stripe_subscription_id }
				}
			}).response;

			if (response.statusCode === 200) {
				alert("Subscription cancelled successfully");
				fetchSubscriptionData(); // Refresh subscription data
			}
		} catch (err) {
			console.error("Error cancelling subscription:", err);
		}
	};

	const formatDate = (timestamp) => {
		return new Date(timestamp * 1000).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	};

	return (
		<div className="max-w-md mx-auto p-6 bg-white rounded-2xl shadow-md">
			<h2 className="text-xl font-bold mb-4">Subscription Pricing</h2>
			
			<div className="mb-4">
				<ImagesStats />
			</div>

			<ul className="mb-4 text-gray-700">
				<li>• Up to 500 MB – Free</li>
				<li>• 500 MB – 10 GB: $2/month</li>
				<li>• 10 GB – 100 GB: $5/month</li>
				<li>• 100 GB+: $10/month</li>
			</ul>

			{loading ? (
				<div className="text-center py-4">Loading subscription info...</div>
			) : subscriptionData?.hasSubscription ? (
				<div className="mb-4">
					<div className="bg-gray-50 p-4 rounded-lg mb-4">
						<h3 className="font-semibold mb-2">Current Subscription</h3>
						<div className="text-sm text-gray-700 space-y-1">
							<p>Status: <span className="font-medium capitalize">{subscriptionData.subscription.status}</span></p>
							<p>Current Period: {formatDate(subscriptionData.subscription.current_period_start)} - {formatDate(subscriptionData.subscription.current_period_end)}</p>
							{subscriptionData.upcomingInvoice && (
								<>
									<p className="mt-2 font-semibold">Next Payment:</p>
									<p>Amount: <span className="font-medium">{subscriptionData.upcomingInvoice.amount_due_formatted}</span></p>
									<p>Date: {formatDate(subscriptionData.upcomingInvoice.next_payment_attempt)}</p>
								</>
							)}
							{subscriptionData.subscription.cancel_at_period_end && (
								<p className="text-red-600 mt-2">Subscription will cancel at period end</p>
							)}
						</div>
					</div>
					<button
						onClick={handleCancel}
						className="w-full py-2 px-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700"
					>
						Cancel Subscription
					</button>
				</div>
			) : (
				<button
					onClick={handleSubscribe}
					className="w-full py-2 px-4 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700"
				>
					Subscribe
				</button>
			)}
		</div>
	);
}

export default UserSubscriptions;
